// extracted by mini-css-extract-plugin
export default {"wrapper":"auth_wrapper__K19r0","errorWrapper":"auth_errorWrapper__z-uVS","appName":"auth_appName__1mGNK","notice":"auth_notice__alrSf","actions":"auth_actions__f0PUp"};